export default "__VITE_ASSET__Btf6d34i__"